/**
 * @file useBoardroomBasePath.ts
 * @brief `/app` vs `/company` base for shared boardroom capture pages.
 *
 * @author DES
 * @date 28-07-2026
 * @updated 13-10-2026 — DES: `/admin` too (a super admin's own Home).
 */

import { useLocation } from "react-router-dom";

/**
 * Capture UI is mounted under employee `/app`, company-admin `/company` and,
 * since a super admin got a Home (13-10-2026), `/admin`.
 */
export function useBoardroomBasePath(): "/admin" | "/app" | "/company" {
  const { pathname } = useLocation();
  if (pathname.startsWith("/company")) return "/company";
  if (pathname.startsWith("/admin")) return "/admin";
  return "/app";
}
